var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 22,
    fill: "#F86E7F",
    fillOpacity: 0.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0858 14.5858C15.5 15.1716 15.5 16.1144 15.5 18V27C15.5 28.8856 15.5 29.8284 16.0858 30.4142C16.6716 31 17.6144 31 19.5 31H25.5C27.3856 31 28.3284 31 28.9142 30.4142C29.5 29.8284 29.5 28.8856 29.5 27V18C29.5 16.1144 29.5 15.1716 28.9142 14.5858C28.3284 14 27.3856 14 25.5 14H19.5C17.6144 14 16.6716 14 16.0858 14.5858ZM19.5 18C18.9477 18 18.5 18.4477 18.5 19C18.5 19.5523 18.9477 20 19.5 20H25.5C26.0523 20 26.5 19.5523 26.5 19C26.5 18.4477 26.0523 18 25.5 18H19.5ZM19.5 22C18.9477 22 18.5 22.4477 18.5 23C18.5 23.5523 18.9477 24 19.5 24H25.5C26.0523 24 26.5 23.5523 26.5 23C26.5 22.4477 26.0523 22 25.5 22H19.5ZM19.5 26C18.9477 26 18.5 26.4477 18.5 27C18.5 27.5523 18.9477 28 19.5 28H23.5C24.0523 28 24.5 27.5523 24.5 27C24.5 26.4477 24.0523 26 23.5 26H19.5Z",
    fill: "#F86E7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.55d52ff7c6579a19dab1bb90b4190fda.svg";
export { ForwardRef as ReactComponent };